import { Nullable } from '@ps/utils';
import { SupplierAllocation } from '@ps/survey-utils';

// View-only supplier allocations for the manage-survey CPI tab — always
// `scope: 'view'` (see manage-survey-reference.effects.ts). The `editable`/
// `update` scopes used at survey-creation time stay in `@ps/survey-data-access`'s
// own `supplier` slice; that one also serves other fields (blends, group
// templates, rate cards) this slice deliberately does not carry.
export interface ManageSurveyReferenceState {
  readonly supplierAllocations: SupplierAllocation[];
  readonly supplierAllocationsLoading: boolean;
  readonly supplierAllocationsError: Nullable<string>;
}

export const INITIAL_MANAGE_SURVEY_REFERENCE_STATE: ManageSurveyReferenceState =
  {
    supplierAllocations: [],
    supplierAllocationsLoading: false,
    supplierAllocationsError: null,
  };
